import PropTypes from "prop-types"
import React, { createContext, useState } from 'react';

export const ImageContext = createContext();

export const ImageProvider = ({ children }) => {
    const [imageData, setImageData] = useState(null);
    return (
        <ImageContext.Provider value={{ imageData, setImageData }}>
            {children}
        </ImageContext.Provider>
    );
};

ImageProvider.propTypes = {
    children: PropTypes.node.isRequired
};